export default __webpack_public_path__ + "static/media/kwongfukbridge_main.b5fed06e.jpg";